module.exports = __webpack_public_path__ + "static/media/PDF AULA INICIAL.38eca10.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/PDF AULA INICIAL.pdf
// module id = 900
// module chunks = 2 7 38